/**
 * Hardcoded ru-копирайт для Экрана 2.0.PWA «Загрузи приложение» (PRD §2.1).
 *
 * Phase 3 — без LinguiJS (см. start.md OUT of scope). Когда придёт i18n,
 * это место становится `defineMessages({...})` без изменений в Presenters.
 */

export const INSTALL_COPY = {
  title: 'Загрузи 1 раз и пользуйся постоянно',
  installCta: 'Загрузи приложение',
  installingLabel: 'Идёт загрузка…',
  unavailableMessage:
    'Установка PWA недоступна в этом браузере. Можно перейти дальше — приложение работает и через браузер.',
  errorRetryMessage: 'Установка не завершилась. Попробуй ещё раз или продолжи без установки.',
  skipCta: 'Перейти дальше →',
  retryCta: 'Попробовать ещё раз',
  iosTitle: 'Установка на iPhone / iPad',
  iosIntro: 'iOS устанавливает приложения через Safari вручную:',
  iosSteps: [
    'Нажми кнопку «Поделиться» внизу экрана',
    'Прокрути меню и выбери «Добавить на экран Домой»',
    'Нажми «Добавить» в правом верхнем углу',
  ] as const,
  iosClose: 'Понятно',
} as const;
